import React from 'react';
import { BaseViewportPlugin } from '@/framework';
import { useStageCropStore } from '../models/crop-stage-state';
import RenderCropStage from './render-crop-stage';

export const CropStagePluginView = React.memo(() => {
    const isCropStage = useStageCropStore()((state) => state.isCropStage);

    if (!isCropStage) {
        return null;
    }

    return (
        <BaseViewportPlugin name="crop-stage">
            <RenderCropStage />
        </BaseViewportPlugin>
    );
});
